import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../defaultState';
import { IGeneralConfigurationReducer } from '../../interfaces/StoreTypes';

const generalConfigurationSlice = createSlice({
    name: 'GeneralConfiguration',
    initialState: initialState.generalConfiguration,
    reducers: {
        showUpgradedModal: (state: IGeneralConfigurationReducer, action) => {
            const payload = action.payload;
            if (typeof payload === 'object' && payload !== null) {
                const open = payload.open ?? true;
                state.showUpgradedModal = open;
                if (open) {
                    state.upgradeModalFromNoAdsCta = payload.fromNoAdsCta ?? false;
                    if (payload.fromNoAdsCta) {
                        state.noAdsCtaSource = payload.noAdsCtaSource ?? null;
                    } else {
                        state.noAdsCtaSource = null;
                    }
                } else {
                    state.upgradeModalFromNoAdsCta = false;
                    state.noAdsCtaSource = null;
                }
            } else {
                state.showUpgradedModal = Boolean(payload);
                state.upgradeModalFromNoAdsCta = false;
                state.noAdsCtaSource = null;
            }
        },
        showGuestRedirectModal: (state: IGeneralConfigurationReducer, action) => {
            state.showGuestRedirectModal = Boolean(action.payload);
        },
        updatePPVCountryConfig: (state: IGeneralConfigurationReducer, action) => {
            state.ppvEventConfig = action.payload;
        },
        // REMOVED: promotions moved to React Query configuration
        // updatePromotions: (state: IGeneralConfigurationReducer, action) => {
        //     state.promotions = action.payload;
        // },
    },
});

export const { showUpgradedModal, showGuestRedirectModal, updatePPVCountryConfig } = generalConfigurationSlice.actions;

export default generalConfigurationSlice.reducer;
